import { useEffect, useState, forwardRef } from "react";
// import { toPng } from 'html-to-image';
import FactorChart from "./FactorChart";
// import useHttp from "../hooks/use-http";

const ChartSteepvl = forwardRef((props, ref) => {
  const { current, ord, factors, type, dictionary, onValid, readOnly, project } = props;
  // const { isLoading, error, sendRequest } = useHttp();
  const [mounted, setMounted] = useState(false);
  const [zoom, setZoom] = useState(false);
  // const chartRef = useRef(null);
  
  // przewidywalnosc na niepewnosc
  let items = factors[type] ?? [];
  items = items.map((el) => {
    return {...el, compare_attr2: (el.compare_attr2 !== undefined && el.compare_attr2 > 0) ? 8 - el.compare_attr2 : 0, xySum: el.compare_attr * 10 + el.compare_attr2 };
  });

  // check duplicates of x,y
  const dupls = [];
  items = items.map((el) => {
    dupls[el.xySum] = (dupls[el.xySum]) ? dupls[el.xySum] + 1 : 1;
    return {...el, counter: dupls[el.xySum] }
  });

  const itemsCount = items.length;
  
  const x = 'compare_attr';
  const y = 'compare_attr2';

  /*
  const minX = 1; // (itemsCount > 0) ? items.reduce((min, p) => p[x] < min ? p[x] : min, items[0][x]) : 1;
  const minY = 1; // (itemsCount > 0) ? items.reduce((min, p) => p[y] < min ? p[y] : min, items[0][y]) : 1;
  const maxX = 7; // (itemsCount > 0) ? items.reduce((max, p) => p[x] > max ? p[x] : max, items[0][x]) : 7;
  const maxY = 7; // (itemsCount > 0) ? items.reduce((max, p) => p[y] > max ? p[y] : max, items[0][y]) : 7;
  */
  const minX = (zoom) ? items.reduce((min, p) => p[x] < min ? p[x] : min, items[0][x]) : 1;
  const minY = (zoom) ? items.reduce((min, p) => p[y] < min ? p[y] : min, items[0][y]) : 1;
  const maxX = (zoom) ? items.reduce((max, p) => p[x] > max ? p[x] : max, items[0][x]) : 7;
  const maxY = (zoom) ? items.reduce((max, p) => p[y] > max ? p[y] : max, items[0][y]) : 7;

  // x axis
  let minXaxis = Math.floor(minX);
  if (minXaxis === minX) { minXaxis -= 0.5; }
  let maxXaxis = Math.ceil(maxX);
  if (maxXaxis === maxX) { maxXaxis += 0.5; }

  // y axis
  let minYaxis = Math.floor(minY);
  if (minYaxis === minY) { minYaxis -= 0.5; }
  let maxYaxis = Math.ceil(maxY);
  if (maxYaxis === maxY) { maxYaxis += 0.5; }

  // x grid
  const xGridCount = (maxXaxis - minXaxis) / 0.5;
  const xGridPercent = 100 / xGridCount;
  const xGrids = [];
  for (let i = 0; i <= xGridCount; i++) {
    xGrids[i] = { lab: (minXaxis + (i * 0.5)), pos: xGridPercent * i };
  }

  // y grid
  const yGridCount = (maxYaxis - minYaxis) / 0.5;
  const yGridPercent = 100 / yGridCount;
  const yGrids = [];
  for (let i = 0; i <= yGridCount; i++) {
    yGrids[i] = { lab: (minYaxis + (i * 0.5)), pos: yGridPercent * i };
  }

  // y dash (x0)
  const xSum = items.reduce((acc, el) => { return acc + el[x]; }, 0);
  const yDash = (xSum > 0) ? xSum / itemsCount : 1;
  const yDashLeft = 100 * ((yDash - minXaxis) / (maxXaxis - minXaxis));
  
  // x dash
  const ySum = items.reduce((acc, el) => { return acc + el[y]; }, 0);
  const xDash = (ySum > 0) ? ySum / itemsCount : 1; // ((maxY - minY) / 2) + minY;
  const xDashBottom = 100 * ((xDash - minYaxis) / (maxYaxis - minYaxis));

  // selected
  // const itemsSelected = items.filter((el) => el.compare_attr > yDash && el.compare_attr2 > xDash);
  // const itemsSelectedId = itemsSelected.map(el => el.id);

  const command = dictionary.command.replace('{time_horizon}', project.time_horizon).replace('{area}', project.area);

  // zoom
  const zoomHandler = () => {
    setZoom(!zoom);
  };
  const zoomIcon = (zoom) ? 'zoom_out_map' : 'zoom_in_map';

  // valid
  useEffect((data) => {
    let valid;
    if (readOnly === true && current < ord) {
      valid = false; // uczen na ekranie grupowym czeka na zatwierdzenie nauczyciela
    } else if (current >= ord) {
      valid = true; // skip - krok juz zapisany
    } else {
      valid = true; // walidacja
    }
    onValid(valid);
  });

  useEffect(() => {
    setTimeout(() => {
      setMounted(true);
    }, 140);
  });

  /* const takePictureHandler = () => {
    if (chartRef.current === null) {
      return
    }

    const url = window.location.pathname + '/upload-image';
    
    toPng(chartRef.current, { cacheBust: false, })
      .then((dataUrl) => {
        console.log(dataUrl);
        // const link = document.createElement('a')
        // link.download = 'my-image-name.png'
        // link.href = dataUrl
        // link.click()

        const data = new FormData();
        data.append('image', dataUrl);
        data.append('image_type', 'steepvl');

        sendRequest({
          url: url,
          method: 'POST',
          body: data
        }, (response) => {
          console.log(response);
        });
      })
      .catch((err) => {
        console.log(err)
      });
  }; */

  
  return (<main className="main-section flex w-100 items-center justify-center">
    <section className="step widex w-100 w-80-l ph3 ph0-l">
      <div className="command w-80-l flex center mb5">
        <div className="f3" dangerouslySetInnerHTML={{ __html: command }}></div>
      </div>
      <div className="relative">
        <div className={`chart-info flex animate-enter-up ${mounted ? 'animated' : ''}`}>
          <div><span className="material-icons mr2">info_outline</span></div>
          <div>{dictionary.info}</div>
        </div>
        <div ref={ref} className="pl4 pb4">
          <div className="card pv7 ph3 pl7-l pr6-l chart relative">
            <div className="chart-content relative">
              {xGrids.map((el, i) => <div key={i} style={{ left: el.pos + '%'}} className="x-grid"><div className="x-label"><div>{(el.lab <= 7 && el.lab >= 1) && el.lab}</div></div></div>)}
              {yGrids.map((el, i) => <div key={i} style={{ bottom: el.pos + '%'}} className="y-grid"><div className="y-label"><div>{(el.lab <= 7 && el.lab >= 1) && el.lab}</div></div></div>)}
              <div className="x-dash" style={{ bottom: xDashBottom + '%'}}>
                <div className="x-dash-tip" style={{ bottom: xDashBottom + '%'}}>{dictionary['x-label']}</div>
              </div>
              <div className="y-dash" style={{ left: yDashLeft + '%'}}>
                <div className="y-dash-tip" style={{ left: yDashLeft + '%'}}>{dictionary['y-label']}</div>
              </div>
              {items.map(item => <FactorChart highlight={item.compare_attr > yDash && item.compare_attr2 > xDash} key={item.id} type={item.type} symbol={item.symbol} name={item.name} legend={dictionary['tip-legend']} legendX={dictionary['importance']} legendY={dictionary['uncertainty']} x={item[x]} y={item[y]} minX={minXaxis} maxX={maxXaxis} minY={minYaxis} maxY={maxYaxis} ceilX="7" ceilY="7" counter={item.counter} />)}
            </div>
            <div className="chart-y-arrow-pos"><div className="chart-y-arrow">{dictionary['uncertainty']}</div></div>
            <div className="chart-x-arrow-pos"><div className="chart-x-arrow">{dictionary['importance']}</div></div>
            <button className="icon-btn btn-primary btn-m chart-zoom" onClick={zoomHandler}>
              <span className="material-icons">{zoomIcon}</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  </main>);
});

export default ChartSteepvl;